var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api } from "./api.service";
export var obterVeiculos = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, veiculos;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/Veiculo?Cpf=".concat(data.cpf, "&Pagina=").concat(data.pagina), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                veiculos = response.data;
                return [2 /*return*/, veiculos];
        }
    });
}); };
export var obterDebitos = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, debitos;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/Veiculo/DebitoVeiculo?Placa=".concat(data.placa), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                debitos = response.data;
                return [2 /*return*/, debitos];
        }
    });
}); };
// retorna o boleto detran de veículo ou condutor
export var obterBoleto = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, boleto;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get(data.placa
                    ? "/Generico/GuiaPagamento?Placa=".concat(data.placa, "&Cpf=").concat(data.cpf, "&ListaIdDebito=").concat(data.listaIdDebito)
                    : "/Generico/GuiaPagamento?Cpf=".concat(data.cpf, "&ListaIdDebito=").concat(data.listaIdDebito), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                boleto = response.data;
                return [2 /*return*/, boleto];
        }
    });
}); };
export var obterListaIpva = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, listaIpva;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/Veiculo/IpvaVeiculo?Placa=".concat(data.placa), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                listaIpva = response.data;
                return [2 /*return*/, listaIpva];
        }
    });
}); };
export var obterBoletoIPVA = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, boleto;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/Veiculo/IpvaVeiculo/GuiaPagamento?NumeroControle=".concat(data.numeroControle), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                boleto = response.data;
                return [2 /*return*/, boleto];
        }
    });
}); };
export var obterCRLVe = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, boleto;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("Veiculo/Crlve?Placa=".concat(data.placa, "&Renavam=").concat(data.renavam, "&Cpf=").concat(data.cpf), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                boleto = response.data;
                return [2 /*return*/, boleto];
        }
    });
}); };
export var obterCertidaoBaixa = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, boleto;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("Veiculo/CertidaoVeiculo/Baixa?Placa=".concat(data.placa), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                boleto = response.data;
                return [2 /*return*/, boleto];
        }
    });
}); };
export var obterCertidaoPropriedade = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, boleto;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("Veiculo/CertidaoVeiculo/Propriedade?Cpf=".concat(data.cpf, "&DataInicio=").concat(data.dataInicio, "&DataFim=").concat(data.dataFim), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                boleto = response.data;
                return [2 /*return*/, boleto];
        }
    });
}); };
export var obterInfracoes = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, infracoes;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("Veiculo/Infracao?Placa=".concat(data.placa), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                infracoes = response.data;
                return [2 /*return*/, infracoes];
        }
    });
}); };
export var incluirGravame = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("Veiculo/ProcessoVeiculo/InclusaoGravame", data, {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
